export const capitalize = (text?: string) => {
  if (!text) return ''

  return text[0].toUpperCase() + text.slice(1).toLowerCase()
}

export const normalize = (text = '') =>
  text
    ? text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
    : text
